import Cookies from 'js-cookie';
import { useParams, useSearchParams } from 'next/navigation';

import { useSession } from '~hooks/useSession';
import type { RouterLocale } from '~i18n/constants';
import { localeCookieName, localeExpires } from '~i18n/constants';
import { usePathname, useRouter } from '~i18n/navigation';
import { userApi } from '~services/api/user';
import { getHost } from '~utils/host';

import { languages } from './names';
import { getLocalizedUrl } from './utils';

export const useLanguage = () => {
	const params = useParams();
	const pathname = usePathname();
	const { userId } = useSession();
	const router = useRouter();
	const searchParams = useSearchParams();
	const [setUserLanguage] = userApi.useSetUserLanguageMutation();
	// Тип locale гарантируется в RootLayout src\app\[locale]\layout.tsx
	// Если бы locale был не RouterLocale, то отрендерилась бы 404
	const { locale } = params as { locale: RouterLocale };

	const changeLanguage = async (locale: RouterLocale) => {
		Cookies.set(localeCookieName, locale, {
			expires: localeExpires,
			domain: getHost(),
		});
		await setUserLanguage({ userId, language: locale }).unwrap();
		router.replace(getLocalizedUrl(searchParams, pathname, locale));
	};

	const language = languages[locale];

	return {
		locale,
		language,
		changeLanguage,
	};
};
